module.exports = __webpack_public_path__ + "static/media/vtc.8a432efa.svg";